module.exports = __webpack_public_path__ + "img/image30.1bc2b9c5.jpg";